/* eslint-disable */
export default {
    methods: {
        goBack() {
            // @ts-ignore
            this.$router.go(-1);
        },
        getRandomInt(min: any, max: any) {
            return Math.floor(Math.random() * (max - min)) + min;
        },
        capitalize(s: any) {
            if (typeof s !== "string") return "";
            const value = s.charAt(0).toUpperCase() + s.slice(1);
            return value;
        },
        capitalizeFirstLetter(string: any) {
            const text =
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            return text;
        },
        isEmptyObj(obj: any) {
            // return 'hey';
            return Object.keys(obj).length === 0;
        },
        getUrlActivity(type: any) {

            let url = null;
      
            switch (type) {
              
              // TEXTO
              case "TEXT":
                url = "text";
                break;
            
              // LINK EXTERNO
              case "EXTERNAL_LINK":
                url =  "link-externo"
                break;
              
              // VIDEO LINK
              case "VIDEO_LINK":
                url = "video";
                break
      
              // PDF
              case "FILE": 
                url = "file";
                break 
      
              // LINK EXTERNO EMBEBIDO
              case "EXTERNAL_LINK_EMBEDDED": 
                url = "link-embebido";
                break 
      
              default:
                url = "pdf";
                break;
            }
      
            return url;
          },

        routePush(routeName: String, params: object) {
          // @ts-ignore
          this.$router.push({ name: routeName, params: {...params}})
        }
    }
};
